<template>
    <div class="infobox" v-bind:class="{ 'd-none': !visible }">
        <div class="infobox-header">
            <div class="infobox-close">
                <button class="btn btn--close" v-on:click="hide">x</button>
            </div>
            <div class="infobox-title hyphens-auto">
                <slot name="title"></slot>
            </div>
            <div class="infobox-subline" v-if="$slots.subline">
                <slot name="subline"></slot>
            </div>
        </div>
        <div class="infobox-body">
            <div class="keyline"></div>
            <div class="overflow-area" ref="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoBox",
        props: ['modalName'],
        data: function ()
        {
            return {
                visible: false,
            };
        },
        methods: {
            hide: function ()
            {
                this.$eventBus.$emit('InfoBox.show', false);
            }
        },
        created()
        {
            this.$eventBus.$on('InfoBox.show', (value) =>
            {
                //console.log('InfoBox.show', value);
                //this.visible = (value !== false);
                if (value === this.modalName)
                {
                    this.$tracking.actionClick('Hotspot: ' + value);
                }
                this.visible = (value === this.modalName);

                let self = this;
                this.$nextTick(() =>
                {
                    if (self.visible)
                    {
                        // Scroll Tracking
                        self.$refs.content.scrollTop = 0;
                        self.$tracking.addScroll('InfoBox-' + self.modalName, self.$refs.content);
                    }
                });
            });
        }
    };
</script>

<style scoped lang="scss">

    @import "../assets/scss/functions";
    @import "../assets/scss/variables";
    @import "../assets/scss/mixins";

    .infobox {

        pointer-events: auto;

        //@include fontFamily(Roman);

        position: absolute;
        z-index: map_get($z-layers, infobox);

        top: gridColumnsToPx(3); //5
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        max-width: gridColumnsToPx(38);
        padding: 0 gridColumnsToRem(1);

        display: flex;
        flex-direction: column;

        animation: fade-in-up 500ms ease-out;


        .infobox-header,
        .infobox-body {
            position: relative;
        }

        .infobox-close {
            position: absolute;
            right: 0;
            top: 0;
            transform: translateY(-100%);
        }

        .infobox-header {

            padding: gridColumnsToRem(3);
            background: $white;
            margin-bottom: psdPxToPx(12);
        }

        .infobox-title {
            @include fontFamily(Heavy);
            font-size: psdPxToRem(60);
        }

        .infobox-subline {
            margin-top: .5em;
            font-size: psdPxToRem(36);
        }

        .infobox-body {
            background: $warm-gray;
            display: flex;
            //overflow-y: hidden;
            overflow: hidden;

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: gridColumnsToRem(3);
                background: linear-gradient(to top, rgba($warm-gray, 1), rgba($warm-gray, 0));
            }
        }

        figure {
            position: relative;
            margin-bottom: 1rem;
        }

        figcaption {
            position: absolute;
            transform: rotate(-90deg) translateY(-100%);
            transform-origin: 0 0;
            color: $gray;
            font-size: .8rem;
            padding: .25em 0;
        }
    }


    .overflow-area {

        overflow-y: auto;
        @supports (-webkit-overflow-scrolling: touch) {
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
        }

        padding: gridColumnsToRem(3);
        padding-bottom: 0;

        > :last-child {
            margin-bottom: gridColumnsToRem(3) !important;
        }
    }

    @media screen and (orientation: landscape) {


        .infobox {

            top: 0; //gridColumnsToRem(-3);

            flex-direction: row;
            align-items: flex-end;
            justify-content: center;

            max-width: 2 * gridColumnsToRem(38);

            .infobox-header,
            .infobox-body {
                flex: 0 1 50%;
                max-width: 50%;
            }

            .infobox-body {
                max-height: 100%;
                order: 10;

                margin-right: psdPxToPx(6);
            }

            .infobox-header {

                margin-bottom: 0;
                order: 20;

                margin-left: psdPxToPx(6);
            }
        }
    }


</style>
